document.addEventListener("DOMContentLoaded", () => {
  //add anchors to all titles in main
  const headings = document.querySelectorAll('h1, h2, h3, h4, h5, h6')
  headings.forEach(h => {
    const hRemovedWS = h.innerHTML.replace(/\s/g, "")
    h.setAttribute("id", hRemovedWS);
  })
})